export default "__VITE_ASSET__Dsn9uDF___"